export enum AutoChargeType {
  PAYMENT_LINK = 'PAYMENT_LINK',
  PSEUDO_NUMBER = 'PSEUDO_NUMBER',
}

export const allChargeTypes = Object.values(AutoChargeType);
